import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const DynamicNav = ({ className = '' }) => {
  const navigate = useNavigate();

  const handleBackNavigation = () => {
    navigate(-1);
  };

  return (
    <nav
     
    >
      <div
        className="flex items-center p-2.5 sm:p-3.5 "
        style={{ position: 'relative', zIndex: 999, marginTop: '-10px' }}
      >
         <button
            onClick={handleBackNavigation}
           
            className="ml-10 group/btn relative flex items-center gap-3 px-6 py-3 rounded-xl bg-gradient-to-r from-orange-400 to-orange-500 border border-gray-200/60 shadow-lg hover:shadow-xl transition-all duration-500 hover:scale-105 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-blue-500/30 overflow-hidden text-white"
            aria-label="Go back to previous page"
            title="Go back"
          >
            {/* Button background animation */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 via-purple-500/5 to-teal-500/5 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-500" />
            
            {/* Icon with animation */}
            <div className="relative flex items-center justify-center">
              <ArrowLeft 
                className={`w-5 h-5 text-gray-600 group-hover/btn:text-blue-600 transition-all duration-500 `} 
              />
              {/* Arrow trail effect */}
              <ArrowLeft 
                className={`absolute w-5 h-5 text-blue-400/40 transition-all duration-300 `} 
              />
            </div>
            
            {/* Text with gradient */}
            <span className="relative font-medium text-white-700 group-hover/btn:text-white-900 transition-colors duration-300">
              Go Back
              <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500 group-hover/btn:w-full transition-all duration-500" />
            </span>
            
            {/* Shine effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover/btn:opacity-100 transform -skew-x-12 group-hover/btn:animate-[shine_0.8s_ease-out] pointer-events-none" />
          </button>
      </div>

      <style jsx>{`
        .premium-breadcrumb {
          background: linear-gradient(
            145deg,
            rgba(255, 255, 255, 0.95) 0%,
            rgba(241, 245, 249, 0.95) 100%
          );
          border-radius: 10px;
          border: 1px solid transparent;
          border-image: linear-gradient(
            to right,
            rgba(45, 212, 191, 0.2),
            rgba(79, 70, 229, 0.2)
          ) 1;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05), 0 2px 6px rgba(0, 0, 0, 0.03),
            inset 0 1px 0 rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(16px);
          position: relative;
          overflow: hidden;
        }

        .premium-breadcrumb::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(45, 212, 191, 0.4),
            rgba(79, 70, 229, 0.4),
            transparent
          );
        }

        @media (max-width: 640px) {
          .premium-breadcrumb {
            margin: 0 4px 10px 4px;
            border-radius: 8px;
            padding: 0.5rem;
          }
        }
      `}</style>
    </nav>
  );
};

export default DynamicNav;